import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ListItem } from "../useFilters";
import clearBlack from "../../../assets/icons/clearBlack.svg";
import getDirection from "../../../utils/getLanguageDirection";
import { ISelectedItemsSummeryProps } from "../../../interfaces/inputs";
import {
  SelectedItemsSummaryContainer,
  SelectedItemsSummaryTitle,
  ClearIcon,
  SelectedItemsList,
} from "./SelectStyles";

const SelectedItemsSummery: React.FC<ISelectedItemsSummeryProps> = ({
  selectedItems,
  title,
  handleRemoveAll,
}) => {
  const { t } = useTranslation();

  const getTitle = useCallback(() => {
    if (!selectedItems.length) return "";

    if (selectedItems.length) {
      if (selectedItems.length === 1) return t(`${selectedItems[0].title}`);
      else return `${title} (${selectedItems.length})`;
    }
  }, [selectedItems, title, t]);

  const direction = getDirection();

  return (
    <SelectedItemsSummaryContainer selectedItemsLength={selectedItems.length}>
      <SelectedItemsSummaryTitle direction={direction}>
        {getTitle()}
      </SelectedItemsSummaryTitle>
      <ClearIcon src={clearBlack} alt="Remove All" onClick={handleRemoveAll} />
      <SelectedItemsList>
        {selectedItems.length &&
          selectedItems.map((item: ListItem, index: number) => (
            <div key={index}>{t(item.title)}</div>
          ))}
      </SelectedItemsList>
    </SelectedItemsSummaryContainer>
  );
};

export default SelectedItemsSummery;
